export default class extends HTMLElement {
  connectedCallback () {
    this.form = this.querySelector('form')
    if (!this.form) return

    this.form.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => this.applyFilters())
    })
  }

  applyFilters () {
    const params = new URLSearchParams(new FormData(this.form))
    const url = `${this.form.action}?${params.toString()}`

    window.location.assign(url)
  }
}
